var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"themeBody",attrs:{"data-theme":_vm.themeMode}},[(_vm.$store.state.isInSlicer == true)?_c('go-back-button',{staticClass:"policiesGoBackButton",attrs:{"is-align-center":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._v("\n      隐私政策\n    ")]},proxy:true}],null,false,4284009685)}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.articleContent)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ca34849","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/policies/privacy.vue
// module id = 354
// module chunks = 0